(function () {
  'use strict';
  const selector='[data-edg-traditional-builder],[data-edg-arctic-builder],[data-edg-standard-martingale-builder],[data-edg-canvas-builder]';
  const one=(root,s)=>root.querySelector(s), all=(root,s)=>Array.from(root.querySelectorAll(s));
  const contexts=new WeakMap();
  const base=()=>window.Shopify?.routes?.root||'/';
  const words=()=>JSON.parse(one(document,'[data-edg-editor-strings]').textContent);
  const editId=()=>new URLSearchParams(location.search).get('edg_edit');
  const buttonFor=root=>one(root,'[data-add-build],[data-ready-to-cart]');
  const group=item=>item.properties?.['_EDG Build'];
  const role=item=>item.properties?.['_EDG Role'];
  const children=(cart,parent)=>cart.items.filter(item=>item.parent_relationship?.parent_key===parent.key || (group(parent)&&group(item)===group(parent)&&role(item)==='extra'));
  const find=(cart,identity)=>cart.items.find(item=>(group(item)===identity&&role(item)==='collar')||item.key===identity);
  function canonical(value) {
    if(Array.isArray(value))return value.map(canonical);
    if(value&&typeof value==='object')return Object.fromEntries(Object.keys(value).sort().map(key=>[key,canonical(value[key])]));
    return value;
  }
  function signature(cart,parent) {
    return JSON.stringify([parent,...children(cart,parent)].map(item=>canonical({id:item.variant_id,quantity:item.quantity,properties:Object.fromEntries(Object.entries(item.properties||{}).filter(([,v])=>v!==''&&v!=null))})).sort((a,b)=>JSON.stringify(a).localeCompare(JSON.stringify(b))));
  }
  async function request(path,payload) {
    const response=await fetch(base()+path,payload?{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)}:{headers:{Accept:'application/json'},cache:'no-store'});
    const result=await response.json();
    if(!response.ok||result.status>=400||result.errors)throw new Error(result.description||result.message||words().update_error);
    return result;
  }
  function capture(root) {
    return {version:1,handle:root.dataset.productHandle,size:root.dataset.sizeValue,width:root.dataset.webbingWidth||(root.matches('[data-edg-canvas-builder]')?'1 inch':''),color:root.dataset.colorValue||root.dataset.patternValue,fi:root.dataset.nativeFiSeries||root.dataset.nativeWidthValue||root.dataset.fiValue||'',closure:root.dataset.closure||'',sizing:root.dataset.edgSizingMode||'guided',neck:one(root,'[data-neck]')?.value||'',head:one(root,'[data-head]')?.value||''};
  }
  function legacy(parent) {
    const p=parent.properties||{}, options=parent.options_with_values||[];
    const option=pattern=>options.find(item=>pattern.test(item.name))?.value||'';
    const measurement=value=>String(value||'').match(/[0-9]+(?:\.[0-9]+)?/)?.[0]||'';
    const fi=p['Fi collar configuration']||option(/Fi Series/i);
    return {handle:parent.handle,size:p['EDG guided size']||option(/^Size$/i),width:p['Webbing width']||p['Collar width']||option(/Webbing Width/i)||(/3\/4/.test(fi)?'3/4 inch':/1 inch/.test(fi)||/canvas/.test(parent.handle)?'1 inch':''),color:option(/^(Color|Pattern)$/i)||p.Color||p['Signature pattern'],fi,closure:/Tactical Buckle/i.test(p['Martingale closure']||'')?'buckle':/martingale/.test(parent.handle)?'slip-over':'',sizing:/Known EDG size/i.test(p['Size selection']||'')||!p['Dog neck']?'known':'guided',neck:measurement(p['Dog neck']),head:measurement(p['Widest head'])};
  }
  function banner(root) {
    let node=one(root,'[data-edg-edit-banner]');if(node)return node;
    node=document.createElement('section');node.className='edg-edit-banner';node.dataset.edgEditBanner='';
    const title=document.createElement('strong');title.textContent=words().editing;
    const status=document.createElement('p');status.dataset.edgEditStatus='';status.setAttribute('role','status');status.textContent=words().loading;
    const quantity=document.createElement('p');quantity.dataset.edgEditQuantity='';
    const cancel=document.createElement('a');cancel.href=base()+'cart';cancel.textContent=words().cancel;
    node.append(title,quantity,status,cancel);root.prepend(node);return node;
  }
  function feedback(root,message,error) {
    const node=one(banner(root),'[data-edg-edit-status]');node.textContent=message||'';node.setAttribute('role',error?'alert':'status');
  }
  function press(root,selector,match) {
    const element=all(root,selector).find(match);
    if(!element||element.disabled)throw new Error(words().restore_error);
    element.click();return element;
  }
  async function restore(root,cart,parent) {
    let state=legacy(parent);
    if(parent.properties?.['_EDG Builder']) {
      const saved=JSON.parse(parent.properties['_EDG Builder']);
      if(saved.version!==1||saved.handle!==root.dataset.productHandle)throw new Error(words().restore_error);
      state=saved;
    }
    const extras=children(cart,parent),p=parent.properties||{};
    const savedTags=window.EDGTagReview.fromCart(root,extras,p['ID Anchor']==='Yes');
    press(root,'[data-edg-sizing-mode]',button=>button.dataset.edgSizingMode===state.sizing);
    await Promise.resolve();
    for(const field of ['neck','head']) {
      const input=one(root,'[data-'+field+']');if(input){input.value=state[field]||'';input.dispatchEvent(new Event('input',{bubbles:true}));}
    }
    if(state.closure)press(root,'[data-closure-choice]',button=>button.dataset.closureChoice===state.closure);
    await new Promise(resolve=>setTimeout(resolve,0));
    // This size was explicitly selected in the existing cart build.
    const allowSavedSize=window.__edgAllowProgrammaticSizeClick;
    window.__edgAllowProgrammaticSizeClick=true;
    try{press(root,'[data-size-choice]',button=>button.dataset.nativeValue===state.size);}
    finally{window.__edgAllowProgrammaticSizeClick=allowSavedSize;}
    await Promise.resolve();
    const fi=one(root,'[data-edg-fi-selector]');
    if(fi) {
      const model=/Series\s*2/i.test(state.fi)?'2':/Series\s*3/i.test(state.fi)?'3':'';
      press(fi,'[data-edg-fi-model]',button=>button.dataset.edgFiModel===model);
      if(!fi.dataset.fixedWidth)press(fi,'[data-edg-fi-webbing]',button=>button.dataset.edgFiWebbing===state.width);
    } else if(!root.matches('[data-edg-canvas-builder]'))press(root,'[data-width-choice]',button=>button.dataset.nativeValue===state.width);
    one(root,'[data-edg-construction-next]').click();
    const color=one(root,'[data-color-select],[data-pattern-select]');
    const match=Array.from(color.options).find(option=>option.value===state.color&&!option.disabled);
    if(!match)throw new Error(words().restore_error);
    color.value=match.value;color.dispatchEvent(new Event('change',{bubbles:true}));
    const nightguard=one(root,'[data-edg-nightguard-toggle]');
    if(nightguard){nightguard.checked=p['NightGuard Reflective Edge']==='Yes';nightguard.dispatchEvent(new Event('change',{bubbles:true}));}
    const chain=one(root,'[data-chain-feature-choice]'),hasChain=/chain/i.test(p['Martingale loop']||'');
    if(chain&&(chain.getAttribute('aria-pressed')==='true')!==hasChain)chain.click();
    await Promise.resolve();
    window.EDGTagReview.restore(root,savedTags);
    root.dataset.edgEditDogName=p['Dog name']||'';
    root.dataset.dogName=p['Dog name']||root.dataset.dogName||'';
    window.EDGSizing.showReview(root);
    const dogLabel=one(root,'[data-review-dog]');if(dogLabel&&p['Dog name'])dogLabel.textContent=p['Dog name'];
    if(!window.EDGSizing.fitState(root).ok)throw new Error(words().restore_error);
    const current=capture(root);
    if(current.size!==state.size||current.color!==state.color||current.width!==state.width||(fi&&current.fi!==state.fi))throw new Error(words().restore_error);
  }
  function payloadSignature(item) {return JSON.stringify(canonical({id:Number(item.variant_id||item.id),quantity:Number(item.quantity),properties:Object.fromEntries(Object.entries(item.properties||{}).filter(([,v])=>v!==''&&v!=null))}));}
  async function syncNative(root) {
    const d=root.dataset;
    const selections=[[d.sizeOption,d.sizeValue],[d.nativeFiSeries||d.fiValue?d.fiOption:d.widthOption,d.nativeFiSeries||d.fiValue||d.nativeWidthValue||d.webbingWidth],[d.colorOption||d.patternOption,d.colorValue||d.patternValue]].filter(([option,value])=>option&&value);
    // Eurus replaces its option controls asynchronously. Reconcile each saved choice
    // against the current controls before allowing the restored build to be updated.
    for(let attempt=0;attempt<20;attempt++) {
      for(const [option,value] of selections) {
        const container=all(document,'.variant-selects-main [data-option-name]').find(node=>node.dataset.optionName===option);
        if(!container)continue;
        const radio=all(container,'input[type="radio"]').find(input=>input.value===value),select=one(container,'select');
        if(radio&&!radio.checked){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));break;}
        if(!radio&&select&&select.value!==value&&Array.from(select.options).some(item=>item.value===value)){select.value=value;select.dispatchEvent(new Event('change',{bubbles:true}));break;}
      }
      await new Promise(resolve=>setTimeout(resolve,250));
      if(window.EDGCheckoutIntegrity?.exactVariant(root))return true;
    }
    return false;
  }
  function verify(cart,items) {
    const parent=find(cart,items[0].properties['_EDG Build']);
    if(!parent)return false;
    const actual=[parent,...children(cart,parent)];
    if(actual.length!==items.length||children(cart,parent).some(child=>child.parent_relationship?.parent_key!==parent.key))return false;
    const a=actual.map(payloadSignature).sort(),b=items.map(payloadSignature).sort();
    return a.every((value,index)=>value===b[index]);
  }
  async function discard(identity) {
    const cart=await request('cart.js'),parent=find(cart,identity);
    if(parent)await request('cart/change.js',{id:parent.key,quantity:0});
    const remaining=await request('cart.js');
    if(find(remaining,identity)||remaining.items.some(item=>group(item)===identity))throw new Error(words().review_error);
  }
  async function addComplete(items) {
    const parentPayload=Object.assign({},items[0]);delete parentPayload.parent_id;
    await request('cart/add.js',{items:[parentPayload]});
    let cart=await request('cart.js'),parent=find(cart,parentPayload.properties['_EDG Build']);
    if(!parent)throw new Error(words().update_error);
    if(items.length>1) {
      const nested=items.slice(1).map(item=>{const next=Object.assign({},item,{parent_line_key:parent.key});delete next.parent_id;return next;});
      await request('cart/add.js',{items:nested});
      cart=await request('cart.js');
    }
    if(!verify(cart,items))throw new Error(words().update_error);
    return cart;
  }
  async function submit(root,source) {
    const context=contexts.get(root),identity=editId();
    if(identity&&(!context||!context.ready))throw new Error(words().loading_error);
    const items=source.map(item=>Object.assign({},item,{quantity:context?.quantity||item.quantity,properties:Object.assign({},item.properties)}));
    if(context) {
      const cart=await request('cart.js'),parent=find(cart,context.identity);
      if(!parent||signature(cart,parent)!==context.signature)throw new Error(words().changed);
    }
    const newIdentity=items[0].properties['_EDG Build'];
    buttonFor(root).textContent=context?words().updating:buttonFor(root).textContent;
    try {
      const cart=await addComplete(items);
      if(context) {
        const parent=find(cart,context.identity);
        if(!parent||signature(cart,parent)!==context.signature)throw new Error(words().changed);
        try {await request('cart/change.js',{id:parent.key,quantity:0});}
        catch(error){const check=await request('cart.js');if(find(check,context.identity))throw error;}
        const finished=await request('cart.js');
        if(find(finished,context.identity)||!verify(finished,items))throw new Error(words().review_error);
      }
    } catch(error) {
      let current;
      try {current=await request('cart.js');}catch(_){throw new Error(words().review_error);}
      if(context&&!find(current,context.identity)) {
        if(verify(current,items))return;
        throw new Error(words().review_error);
      }
      try {await discard(newIdentity);}catch(_){throw new Error(words().review_error);}
      throw error;
    } finally {if(context)buttonFor(root).textContent=words().update;}
  }
  async function boot(attempt=0) {
    if(!editId())return;
    const root=one(document,selector);if(!root)return;
    if(root.dataset.edgEditorStarted)return;
    banner(root);buttonFor(root).disabled=true;
    if(root.dataset.initialized!=='true'||!one(root,'[data-edg-tag-review]')?.dataset.ready||!window.EDGSizing||!window.EDGBuildCommerce||(one(root,'[data-edg-fi-selector]')&&!one(root,'[data-edg-fi-selector]').dataset.ready)) {
      if(attempt<80){setTimeout(()=>boot(attempt+1),75);return;}
      feedback(root,words().restore_error,true);return;
    }
    root.dataset.edgEditorStarted='true';
    try {
      const cart=await request('cart.js'),parent=find(cart,editId());
      if(!parent||parent.handle!==root.dataset.productHandle)throw new Error(words().missing);
      const context={identity:editId(),quantity:parent.quantity,signature:signature(cart,parent),ready:false};contexts.set(root,context);
      await restore(root,cart,parent);
      if(!await syncNative(root))throw new Error(words().restore_error);
      window.EDGBuildCommerce.refresh(root);context.ready=true;
      one(banner(root),'[data-edg-edit-quantity]').textContent=words().quantity.replace('[quantity]',String(parent.quantity));
      feedback(root,'',false);buttonFor(root).disabled=false;buttonFor(root).textContent=words().update;
    }catch(error){feedback(root,error.message||words().restore_error,true);buttonFor(root).disabled=true;}
  }
  window.EDGBuildEditor={capture,submit,verify,signature,label:root=>contexts.has(root)?words().update:''};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot());else boot();
  document.addEventListener('shopify:section:load',()=>boot());
})();
